import { t } from 'i18next';
import ConfirmationDrawer from '../confirmation-drawer/confirmation-drawer.component';
import { useDeleteRuleMutation } from 'api/ml-service/ml-service';

export type DeleteCustomRuleDrawerData = {
  ruleId: string;
} | null;

type DeleteCustomRuleDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData: DeleteCustomRuleDrawerData;
};

const DeleteCustomRuleDrawer = ({
  open,
  close,
  drawerData,
}: DeleteCustomRuleDrawerProps) => {
  const [deleteRule] = useDeleteRuleMutation();

  const handleDelete = async () => {
    await deleteRule({ ruleId: drawerData.ruleId });
    close();
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      subtitle={t('drawer.deleteCustomRuleDrawer.subtitle')}
      color="error"
      onValid={async () => {
        await handleDelete();
      }}
      submitButtonLabel={t('drawer.deleteButton.label')}
    />
  );
};

export default DeleteCustomRuleDrawer;
